import { NotificationType } from '@govinity/shared-config';
import { z } from 'zod';
import { paginationSchema } from '../shared/index.js';
export { NotificationType };
export const notificationsQuerySchema = paginationSchema;
export const notificationUpdateSchema = z.object({
    read: z.boolean('Read is required'),
});
